export default __webpack_public_path__ + "static/handyman-5972590df98b96ed84ff325f09293aa2.png";